import { render, staticRenderFns } from "./pageSearchResults.vue?vue&type=template&id=fd5a8de4&"
import script from "./pageSearchResults.vue?vue&type=script&lang=js&"
export * from "./pageSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports